/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LinkedInChatMessageResponseDirection = typeof LinkedInChatMessageResponseDirection[keyof typeof LinkedInChatMessageResponseDirection];


export const LinkedInChatMessageResponseDirection = {
  inbound: 'inbound',
  outbound: 'outbound',
} as const;
